import { cx } from "@emotion/css";
import { Typography } from "antd";

export const BrandFooter = () => {
  return (
    <div
      className={cx(
        "fixed bottom-0 left-0",
        "mb-6",
        "w-full",
        "text-sm text-white text-center"
      )}
    >
      Version 2.0.0 Copyright © &nbsp;
      <a className="text-white" href="https://pacport.co.jp/">
        PacPort
      </a>{" "}
      All rights reserved.
    </div>
  );
};
